export default "/images/vendor/flag-icon-css/flags/1x1/uy.svg?091841c8018480091faefbc9124eb3eb";